module.exports = __webpack_public_path__ + "ed70c9263b76405afa7d179f5ee5858c.wmv";